import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, isRef as _isRef, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-question__title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "tw-question__title__asterisk" }, " *", -1)
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "tw-form-control" }
const _hoisted_5 = ["placeholder", "aria-label", "aria-describedby", "rows", "name", "autocomplete", "aria-invalid"]
const _hoisted_6 = ["placeholder", "aria-label", "aria-describedby", "rows", "aria-invalid"]
const _hoisted_7 = ["id"]
const _hoisted_8 = {
  key: 2,
  class: "tw-question__title mt-5"
}

import { InterviewQuestionResponseModel } from '@/models/QuestionModels'
import { useInterviewStore } from '@/stores/interviewStore'
import { computed, ref, watch, onMounted } from 'vue'
import FlatButton from '@/components/Shared/FlatButton.vue'
import { QuestionType } from '@/models/QuestionType';
import { scrollToElementBottom } from '../scrollToElementBottom';


export default /*#__PURE__*/_defineComponent({
  __name: 'TextQuestion',
  props: {
    question: null
  },
  emits: ['handleAnswerChoose'],
  setup(__props: any, { emit: emits }) {

const props = __props as { question: InterviewQuestionResponseModel };

const answer = ref<string>('')
const isSubmited = ref<boolean>(false)
const rows = ref<number>(1);
const isSingleLane = ref<boolean>(false);

const root = ref<HTMLElement | undefined>(undefined);



const touched = ref(false);

const interviewStore = useInterviewStore()
const textInputPlaceholder = interviewStore.getLocalization('InterviewQuestionary.TextQuestion.Placeholder')

const nextBtnText = computed(() => interviewStore.getLocalization('InterviewQuestionary.Common.NextQuestionButton'))
const errorMessage = computed(() => interviewStore.questionsAnswerError[props.question.Id])
const isSubmitable = computed(() => {
    validateField()
    return !!answer.value
});

const isNameQuestion = computed(() => props.question.Type === QuestionType.NameQuestion)
const welcomeText = computed(() => interviewStore.getLocalization('InterviewQuestionary.WelcomeText'))
const welcomeTextComp = computed(() => {
    if (interviewStore.userName && welcomeText.value) {
        return welcomeText.value.replace('{{name}}',interviewStore.userName)
    }
    return ''
})

onMounted(() => {
    if (props.question.Type === QuestionType.RichTextQuestion) {
        rows.value = 16;
    }

    if(props.question.Type === QuestionType.NameQuestion) {
        isSingleLane.value = true
    }

    scrollToElementBottom(root!.value as HTMLElement);
})

function submitQuestion() {
    if (!isSubmitable.value || (interviewStore.isLastQuestion && interviewStore.checkError())) {
        return
    }

    interviewStore.nextQuestion()
    interviewStore.setUserName(answer.value)
    isSubmited.value = true
}

function pushAnswer(ans: string | null) {
    if (ans && ans?.length > 0) {
        interviewStore.changeAnswer(props.question.Id, ans)
    }
}

function validateField() {
    if (!answer.value && touched.value) {
        interviewStore.questionsAnswerError[props.question.Id] = isNameQuestion.value ?
            interviewStore.getLocalization('Accessability.InterviewQuestionary.NameField.Empty') :
            props.question.Type === QuestionType.RichTextQuestion ?
                interviewStore.getLocalization('Accessability.InterviewQuestionary.RichTextField.Empty') :
                interviewStore.getLocalization('Accessability.InterviewQuestionary.TextField.Empty')
    }else{
        interviewStore.questionsAnswerError[props.question.Id] = null
    }
}

watch(answer, (newValue) => {
    emits('handleAnswerChoose', newValue)
    pushAnswer(newValue)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: _normalizeClass(["tw-question", {'tw-name-question': __props.question.Type === _unref(QuestionType).NameQuestion}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(_toDisplayString(__props.question.Title), 1),
      _hoisted_2
    ]),
    (!!__props.question.Description)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "text-question-desc",
          innerHTML: __props.question.Description,
          class: "tw-question__description"
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (isSingleLane.value)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((answer).value = $event)),
            placeholder: __props.question.Label ?? _unref(textInputPlaceholder),
            "aria-label": __props.question.Label,
            "aria-describedby": _unref(errorMessage) ? 'text-question-error-' + __props.question.Id : 'text-question-desc',
            onBlur: _cache[1] || (_cache[1] = ($event: any) => (touched.value = true)),
            rows: rows.value,
            name: _unref(isNameQuestion) ? 'name' : '',
            autocomplete: _unref(isNameQuestion) ? 'name' : '',
            "aria-required": "true",
            "aria-invalid": touched.value && !_unref(isSubmitable),
            class: _normalizeClass(["tw-form-control__textarea", {
                        'tw-form-control__field-error--highlight': touched.value && !_unref(isSubmitable),
                        'tw-form-control__textarea--error': touched.value && !_unref(isSubmitable),
                        'tw-form-control__textarea--no-resize': __props.question.Type === _unref(QuestionType).TextQuestion || __props.question.Type === _unref(QuestionType).NameQuestion,
                      }])
          }, null, 42, _hoisted_5)), [
            [_vModelText, answer.value]
          ])
        : _withDirectives((_openBlock(), _createElementBlock("textarea", {
            key: 1,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((answer).value = $event)),
            placeholder: __props.question.Label ?? _unref(textInputPlaceholder),
            "aria-label": __props.question.Label,
            "aria-describedby": _unref(errorMessage) ? 'text-question-error-' + __props.question.Id : 'text-question-desc',
            onBlur: _cache[3] || (_cache[3] = ($event: any) => (touched.value = true)),
            rows: rows.value,
            "aria-required": "true",
            "aria-invalid": touched.value && !_unref(isSubmitable),
            class: _normalizeClass(["tw-form-control__textarea", {
                        'tw-form-control__field-error--highlight': touched.value && !_unref(isSubmitable),
                        'tw-form-control__textarea--error': touched.value && !_unref(isSubmitable),
                        'tw-form-control__textarea--no-resize': __props.question.Type === _unref(QuestionType).TextQuestion || __props.question.Type === _unref(QuestionType).NameQuestion,
                      }])
          }, null, 42, _hoisted_6)), [
            [_vModelText, answer.value]
          ]),
      (_unref(errorMessage))
        ? (_openBlock(), _createElementBlock("span", {
            key: 2,
            class: "tw-question__error",
            id: 'text-question-error-' + __props.question.Id,
            role: "alert",
            "aria-live": "polite"
          }, _toDisplayString(_unref(errorMessage)), 9, _hoisted_7))
        : _createCommentVNode("", true)
    ]),
    (_unref(isSubmitable) && !isSubmited.value)
      ? (_openBlock(), _createBlock(FlatButton, {
          key: 1,
          onClick: submitQuestion,
          modelValue: _unref(nextBtnText),
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(nextBtnText) ? (nextBtnText).value = $event : null)),
          bgColor: '#2C267A',
          isArrowStyle: true
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_unref(isNameQuestion) && _unref(welcomeTextComp) && isSubmited.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(welcomeTextComp)), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})